module.exports = __webpack_public_path__ + "img/sprint400.5d702357.png";